import { useState } from "react";
import { envService } from "src/services/environments";

interface UseEnvironmentsListProps {
  organizationId: string;
}

export const useEnvironments = ({
  organizationId,
}: UseEnvironmentsListProps) => {
  const [environments, setEnvironments] = useState<any[]>([]);
  const [isLoadingEnv, setIsLoadingEnv] = useState(false);

  const getEnvironments = async () => {

    try {
      setIsLoadingEnv(true);
      const responseData = await envService.getEnvironmentByOrganization(
        organizationId
      );
      
      const dataToSend = responseData?.records?.map((env: any) => ({
        value: env.id,
        label: env.fullname,
        other: {
          clusterID: env.clusterId,
        }
      }));
      setEnvironments(dataToSend);
    } catch (error) {
      setEnvironments([]);
    } finally {
      setIsLoadingEnv(false);
    }
  }

  return {
    environments,
    isLoadingEnv,
    getEnvironments
  };
};
